import SpotifyPlayer from "../../../../content/posts/example-markdown/SpotifyPlayer";
import * as React from 'react';
export default {
  SpotifyPlayer,
  React
};